export default "__VITE_ASSET__DNs3LRZt__"